import { SubjectValuePaths } from '@hcs/types';

export const SELECTED_VALUE_PATH: SubjectValuePaths = '/data/selectedValue';
